import { motion, AnimatePresence } from 'framer-motion';
import { useUI } from '@/store/ui';

const COLOR = {
  info: 'bg-accent text-text-inverse',
  success: 'bg-success text-white',
  error: 'bg-danger text-white',
} as const;

export function Toast() {
  const toast = useUI(s => s.toast);
  return (
    <AnimatePresence>
      {toast && (
        <div
          className="fixed inset-x-0 z-[100] flex justify-center pointer-events-none px-4"
          style={{
            bottom: 'calc(var(--tg-safe-area-inset-bottom, env(safe-area-inset-bottom, 0px)) + 5rem)',
          }}
        >
          <motion.div
            className={`px-4 py-2.5 rounded-lg shadow-lg text-sm text-center max-w-[420px] pointer-events-auto ${COLOR[toast.type]}`}
            initial={{ y: 20, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: 20, opacity: 0 }}
          >
            {toast.message}
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
}
